import { IntlShape } from "react-intl";
import { z } from "zod";
import { occupationTypesMessages } from "./messages";

export const _occupancyFormSchema = z.object({
  occupationType: z
    .object({
      value: z.string(),
      label: z.string(),
    })
    .required(),
  occupationFilterType: z
    .object({
      value: z.string(),
      label: z.string(),
    })
    .required(),
  minChildrenAge: z.coerce.number().min(0).nullable(),
  maxChildrenAge: z.coerce.number().min(0).nullable(),
  minBabiesAge: z.coerce.number().min(0).nullable(),
  maxTeensAge: z.coerce.number().min(0).nullable(),
  maxSeniorsAge: z.coerce.number().min(0).nullable(),
  filterByAge: z.boolean(),
  baseAccommodationType: z
    .object({
      value: z.string(),
      label: z.string(),
    })
    .required(),
});

export const occupancyFormSchema = (intl: IntlShape) =>
  _occupancyFormSchema.superRefine((data, context) => {
    if (
      data.minChildrenAge !== null &&
      data.maxChildrenAge !== null &&
      data.minChildrenAge > data.maxChildrenAge
    ) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["minChildrenAge"],
        message: intl.formatMessage(
          occupationTypesMessages.errorMinChildrenAgeGreaterMaxChildrenAge
        ),
      });
    }

    if (
      data.maxChildrenAge !== null &&
      data.maxTeensAge !== null &&
      data.maxChildrenAge > data.maxTeensAge
    ) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["maxChildrenAge"],
        message: intl.formatMessage(occupationTypesMessages.errorMaxChildrenAgeGreaterMaxTeensAge),
      });
    }

    if (
      data.minBabiesAge !== null &&
      data.minChildrenAge !== null &&
      data.minBabiesAge > data.minChildrenAge
    ) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["minBabiesAge"],
        message: intl.formatMessage(occupationTypesMessages.errorMinBabiesAgeGreaterMinChildrenAge),
      });
    }
  });

export type OccupancyFormInput = z.input<typeof _occupancyFormSchema>;
export type OccupancyFormData = z.output<typeof _occupancyFormSchema>;
